import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

const LanguageSwitch = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 font-medium"
      aria-label="Change language"
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase">{i18n.language === 'es' ? 'EN' : 'ES'}</span>
    </Button>
  );
};

export default LanguageSwitch;
